import apiService from '#services/api';

export const payoutStatuses = [
  'PENDING', 'PROCESSING', 'FAILED', 'COMPLETED', 'REFUNDING', 'CANCELLED',
] as const;

export type PayoutStatus = typeof payoutStatuses[number];

export type Deal = {
  dealId: string;
  paymentId: string;
  e2cPaymentId: string | null;
  createdAt: string;
  updatedAt: string;
  status: PayoutStatus;
  errorMessage: string | null;
};

export type DealsPage = {
  page: number;
  size: number;
  total: number;
  isLast: boolean;
  data: Deal[];
};

export const dealsService = {
  list(params: { page: number; size: number; status?: PayoutStatus; sortOrder?: 'asc' | 'desc' }) {
    const searchParams = new URLSearchParams();
    searchParams.set('page', String(params.page));
    searchParams.set('size', String(params.size));
    if (params.status) searchParams.set('status', params.status);
    if (params.sortOrder) {
      searchParams.set('sortBy', 'createdAt');
      searchParams.set('sortOrder', params.sortOrder);
    }
    return apiService.request.get('v2/admin/supplier-payouts', { searchParams }).json<DealsPage>();
  },
  retry(dealId: string) {
    return apiService.request.post(`v2/admin/supplier-payouts/${encodeURIComponent(dealId)}/retry`).json();
  },
};
